<template>
  <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-ndescuento">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"><b>Solicitar Descuento</b></h5>
        </div>

        <div class="modal-body" v-if="ins && ins.estudiante">
          <p class="mb-0">
            <b>Estudiante:</b> {{ ins.estudiante.nombres }} {{ ins.estudiante.pri_apellido }}
            {{ ins.estudiante.seg_apellido }}
          </p>
          <p><b>Asesor:</b> {{ ins.asesor.nombres }} {{ ins.asesor.pri_apellido }} {{ ins.asesor.seg_apellido }}</p>

          <p class="mb-0"><span class="text-danger">*</span> Concepto para descontar</p>
          <div>
            <select class="form-control" v-model.number="concepto">
              <option value=""></option>
              <option v-for="(c, ind) in conceptos" :key="ind" :value="c"> ({{ c.id }}) {{ c.nombre }} </option>
            </select>
            <small v-if="concepto" class="blue--text ml-1">
              <b>Monto:</b> {{ concepto.monto }} bs, <b>Saldo:</b> {{ concepto.saldo }} bs
            </small>
          </div>

          <p class="mb-0 mt-4"><span class="text-danger">*</span> Motivo del descuento</p>
          <div>
            <select class="form-control" v-model="motivo">
              <option v-for="(m, ind) in motivos" :key="ind" :value="m"> {{ m.descripcion }} </option>
            </select>
          </div>

          <p class="mb-0 mt-4"><span class="text-danger">*</span> Ingrese el monto del descuento</p>
          <v-radio-group v-model="porcentual" row dense hide-details class="mt-0 xcard pa-0">
            <v-radio label="Entero" :value="false"></v-radio>
            <v-radio label="Porcentual" :value="true"></v-radio>
            <v-col cols="4" class="pt-0">
              <v-text-field
                hide-details=""
                v-model.number="monto"
                :rules="validarCampo()"
                type="number"
                :label="porcentual ? 'Porcentaje descuento' : 'Monto descuento'"
                :prefix="porcentual ? '' : 'Bs:'"
                :suffix="porcentual ? '%' : ''"
                placeholder="....."
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="pt-0" v-if="porcentual">
              <v-text-field
                hide-details=""
                v-model.number="monto_porcentual"
                prefix="$"
                :disabled="true"
                type="number"
                label="Monto"
                placeholder="..."
              ></v-text-field>
            </v-col>
          </v-radio-group>

          <label for="H" class="mb-0 mt-4"> <input type="checkbox" v-model="prorratear" /> Prorratear </label>
          <span> (Seleccione si desea prorratear) </span>

          <p class="mb-0 mt-4"><span class="text-danger">*</span> Descripcion del descuento</p>
          <div>
            <textarea
              class="form-control"
              v-model.trim="descripcion"
              rows="4"
              placeholder="Ingrese una descripcion de la solicitud de descuento..."
            >
            </textarea>
          </div>

          <v-container v-show="false">
            <v-row>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Lugar*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-city"
                  hint="Monto de descuento"
                  maxLength="50"
                  vv-model.trim="lugar"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Carnet*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-account-box"
                  hint="Carnet de identidad"
                  maxLength="20"
                  vv-model.trim="carnet"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Correo*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-email"
                  hint="Correo electronico"
                  maxLength="45"
                  vv-model.trim="email"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Telefono*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-phone"
                  hint="Telefono o celular"
                  maxLength="12"
                  vv-model.trim="telefono"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <p class="text-center text-danger">
            <b>{{ msg }}</b>
          </p>
          <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="validar()" :disabled="loading || exitoso" type="button" class="btn btn-azul white--text">
            Solicitar
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    props: { ins: { type: Object, required: true } },
    data() {
      return {
        motivos: [],
        descuentostipos: [],
        conceptos: [],
        xins: {},
        xprograma: {},
        msg: '',
        loading: false,

        motivo: {},
        concepto: null,
        prorratear: false,
        monto: null,
        monto_porcentual: null,
        inscripcion_id: null,
        descripcion: '',
        porcentual: false,
        exitoso: false,
      };
    },
    watch: {
      concepto: function() {
        this.verificardescuentoporcentual();
      },
      monto: function() {
        this.verificardescuentoporcentual();
      },
      porcentual: function() {
        this.verificardescuentoporcentual();
      },
    },
    components: {},
    methods: {
      validarCampo() {
        let nameRules = [(v) => !this.porcentual || v <= 100 || 'Error'];
        return nameRules;
      },
      verificardescuentoporcentual() {
        if (!this.concepto || !this.monto) return;
        if (this.porcentual) {
          if (this.monto > 100) this.monto = 100;
          this.monto_porcentual = Math.round(this.concepto.monto * (this.monto / 100));
        }
      },
      getdescuentostipo(ins, programita) {
        //window.console.log('descuentos tipos....', programita);
        this.xprograma = programita;
        this.msg = '';
        this.motivo = {};
        this.concepto = null;
        this.monto = null;
        this.monto_porcentual = null;
        this.porcentual = false;
        this.exitoso = false;
        this.prorratear = false;
        this.descripcion = '';
        this.xins = ins;
        this.inscripcion_id = ins.id;
        this.motivos = [];
        this.loading = true;
        const vue = this;
        let id_inscripcion = ins.id;
        let unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
        const urlm = `${process.env.VUE_APP_API_REST}/api/v1/motivos?descuento_tipo_id=2&unidad_negocio_id=${unidad_negocio_id}`; // el 2 ni idea del porque
        const urld = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
        const urlc =
          `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/concepto_pagos?acepta_descuento=true&inscripcion_id=` +
          id_inscripcion;
        const urlp = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${id_inscripcion}/plan-pago`;
        const promise1 = xaxios.get(urlm);
        const promise2 = xaxios.get(urld);
        const promise3 = xaxios.get(urlc);
        const promise4 = xaxios.get(urlp);

        Promise.all([promise1, promise2, promise3, promise4]).then(function(values) {
          let data0 = values[0];
          let data1 = values[1];
          let data2 = values[2];
          if (data0.data == '') data0 = { data: { data: [] } };
          if (data1.data == '') data1 = { data: { data: [] } };

          data1.data.data.forEach((x) => {
            vue.descuentostipos.push(x);
          });
          data0.data.data.forEach((x) => {
            let tipodes = vue.descuentostipos.find((t) => t.id == x.descuento_tipo);
            x.xtipodes = tipodes;
            vue.motivos.push(x);
          });
          //window.console.log('CONCEOTS:', data2);
          vue.parseconceptos(data2.data.data);
          vue.loading = false;
        });
      },
      parseconceptos(datos) {
        if (!datos) datos = [];
        let xdatos = [];
        datos.forEach((x) => {
          let d = xdatos.find((a) => a.id == x.id);
          if (!d && x.id != 3) xdatos.push(x);
        });
        this.conceptos = xdatos;
        if (this.conceptos.length == 0) this.msg = 'No hay conceptos que acepten descuentos';
      },
      validar() {
        this.msg = '';
        if (!this.inscripcion_id) {
          this.msg = 'Inscripcion no encontrada';
          return;
        }
        if (!this.motivo.id) {
          this.msg = 'Seleccione un motivo.';
          return;
        }
        if (!this.monto) {
          this.msg = 'Ingrese el monto de descuento.';
          return;
        }
        if (!this.concepto) {
          this.msg = 'Seleccione un concepto de descuento.';
          return;
        }
        if (!this.descripcion) {
          this.msg = 'Escriba una descripcion para soliciatr el descuento';
          return;
        }
        if (this.porcentual && this.monto > 100) {
          this.msg = 'El monto porcentual no debe pasar el 100%';
          return;
        }
        /* if (this.monto % 1 !== 0) {
          this.msg = 'El monto de descuento debe ser un numero entero';
          return;
        } */
        if (this.monto <= 0) {
          this.msg = 'El monto de descuento debe ser un numero entero positivo mayor a cero';
          return;
        }

        let xmonto = this.monto;
        if (this.porcentual) {
          xmonto = this.monto_porcentual;
        }
        if (xmonto > this.concepto.saldo) {
          this.msg =
            'El monto de descuento no puede ser superior al saldo pendiente del concepto: ' + this.concepto.nombre;
          return;
        }

        let data = {
          descripcion: this.descripcion,
          inscripcion_id: this.inscripcion_id,
          monto: xmonto,
          motivo_id: this.motivo.id,
          concepto_pago_id: parseInt(this.concepto.id),
          prorrateado_activo: this.prorratear,
        };

        window.console.log(data);
        this.enviar(data);
      },
      enviar(data) {
        const vue = this;
        vue.loading = true;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/solicitud`;
        xaxios
          .post(url, data)
          .then((res) => {
            window.console.log(res);
            vue.msg = res.data.data;
            vue.loading = false;
            vue.exitoso = true;
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = 'Puede que ya tenga un descuento pendiente de aprobacion o el monto sobrepasa la cuota';
            if (error.response) {
              vue.msg = error.response.data.data;
            }
            vue.loading = false;
          });
      },
    },
    mounted() {
      var vue = this;
      window.$('#modal-ndescuento').on('hide', function() {
        vue.msg = '';
        vue.motivo = {};
        vue.monto = null;
        vue.inscripcion_id = null;
        vue.descripcion = '';
      });
    },
  };
</script>
